"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setCookie = setCookie;
exports.removeCookie = removeCookie;
exports.getCookie = getCookie;
/**
 * Generete expires time
 * @param hours total hours
 */
function getExpires(hours) {
    if (typeof hours === 'number') {
        var d = new Date();
        d.setTime(d.getTime() + hours * 60 * 60 * 1000);
        var expires = 'expires=' + d.toUTCString();
        return ";".concat(expires);
    }
    return ';';
}
/**
 * Set cookue
 * @param name cookie name
 * @param value cookie value
 * @param hours cookie expires
 */
function setCookie(name, value, hours) {
    document.cookie = "".concat(name, "=").concat(value, ";domain=").concat(__DOMAIN__).concat(getExpires(hours), ";path=/");
}
/**
 * Remove cookie
 * @param name cookie name
 */
function removeCookie(name) {
    document.cookie = "".concat(name, "=;domain=").concat(__DOMAIN__).concat(getExpires(-500000), ";path=/");
}
/**
 * Return cookie if found otherwise return undefined
 * @param name cookie name
 */
function getCookie(name) {
    var key = "".concat(name, "=");
    var decodedCookie = decodeURIComponent(document.cookie);
    var cookies = decodedCookie.split(';');
    var cookie = cookies.find(function (c) { return c.trim().indexOf(key) === 0; });
    if (cookie !== undefined) {
        var trimmed = cookie.trim();
        return trimmed.substring(key.length, trimmed.length);
    }
    return undefined;
}
